import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ICompanyDetailForAgentClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanyDetailForAgentClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class CompanyDetailForAgentClient implements ICompanyDetailForAgentClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, companyId, supporterToken } = input;
        const PATH = `${API_LOCATION_URL}/agent/company/detail/${companyId}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        if (token) {
            headers['X-HTTP-AUTH-TOKEN-A'] = token;
        }
        if (supporterToken) {
            headers['X-HTTP-AUTH-TOKEN-S'] = supporterToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
